module.exports = __webpack_public_path__ + "files/a7be859d2bbdae80c3606b558d0138fe.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-120x120.png
// module id = 562
// module chunks = 60